module.exports = __webpack_public_path__ + "img/alejandro-toledo.732b0d70.png";